import {Skeleton} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import React from 'react';

export const LoadingSkeleton = () => {
	const {isLaptop} = useMediaQueries();
	return (
		<StyledGrid.Root spacing={2}>
			{Array.from({length: isLaptop ? 3 : 6}).map((_, index) => (
				<StyledGrid.Item key={index} xs={12} sm={12} md={12} lg={4} xl={4}>
					<Skeleton variant="rectangular" height={149} />
				</StyledGrid.Item>
			))}
		</StyledGrid.Root>
	);
};
